/**
 * @name getFvpNetworkCode
 * @description This function provides a fvp network code which contains siteId siteDomain and mcmId
 *
 *
 * @param {{siteId}} siteId
 * @param {{mcmId}} mcmId
 * @param {{siteDomain}} siteDomain
 *
 * */
export const getFvpNetworkCode = (siteId, siteDomain, mcmId) => {
	return `https://pubads.g.doubleclick.net/gampad/ads?iu=/103512698,${mcmId}/ap_instream_vpaid&description_url=${siteDomain}&tfcd=0&npa=0&sz=1x1%7C640x480&cust_params=hb_ap_siteid%3D${siteId}&gdfp_req=1&output=xml_vast4&env=vp&unviewed_position_start=1&impl=s&correlator=`;
};
